import { createApp,reactive} from 'vue'
import App from './App.vue'
import './global.css'; // 引入全局样式文件
import eventBus from './useEventBus.js'; // 引入事件总线
import router from './router/router.js'; // 引入路由配置

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

const searchParams = new URLSearchParams(window.location.search);
const queryParams = Object.fromEntries(searchParams.entries());
const parameter = reactive({
    parameter:queryParams
})

const hostname = window.location.protocol+window.location.hostname+":"+window.location.port;

const app = createApp(App);
app.config.globalProperties.$globalVariable = hostname;
app.provide('parameter', parameter.parameter);
app.provide('eventBus', eventBus);
app.use(router);
app.use(ElementPlus, { locale: zhCn });

app.directive('positive', {
mounted(el) {
    el.addEventListener('input', (e) => {
        let value = e.target.value;
    
        // 1. 允许数字和小数点
        value = value.replace(/[^0-9.]/g, '');
        
        // 2. 处理多个小数点
        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts.slice(1).join('');
        }
        // 3. 处理前导零（保留0.x格式）
        if (value.length > 1 && value[0] === '0' && value[1] !== '.') {
            value = value.slice(1);
        }
        e.target.value = value;
    });
    el.addEventListener('blur',(e) => {
        let value = e.target.value;
        // 1. 处理空值/无效值
        if (value === '' || value === '.') {
            value = '0';
        }
        // 2. 处理格式
        if (value.startsWith('.')) {
            value = '0' + value;
        }
        // 3. 分割整数和小数部分
        const [intPart, decimalPart] = value.split('.');
        
        // 4. 格式化整数部分（保留单个0）
        let formattedInt = intPart.replace(/^0+/, '') || '0';
        
        // 5. 限制小数位数（这里设为2位）
        let formattedDecimal = '';
        if (decimalPart !== undefined) {
            formattedDecimal = decimalPart.slice(0, 2); // 保留最多2位小数
        }
        // 6. 组合最终值
        value = formattedDecimal 
            ? `${formattedInt}.${formattedDecimal}`
            : formattedInt;
        
        // 7. 确保最小值（允许0）
        if (parseFloat(value) < 0) {
            value = '0';
        }
        
        e.target.value = value;
    })
}
});

app.mount('#app');



